// TODO: Add manual areas when fddm supports it
export const validTargetAreas = ['DELIVERY'];
export const validWaitAreas = ['CHARGING', 'PARKING'];
